import { createPlugin } from '#pplx/frontend/composer-sdk/plugins/createPlugin.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
const VOICE_MODE_PLUGIN_ID = 'voice-mode';
const VOICE_MODE_PRIORITY = 40;
export function createVoiceModePlugin({ isEnabled, label, onOpen, isActive = false, }) {
    return createPlugin({
        id: VOICE_MODE_PLUGIN_ID,
        capabilities: [
            {
                kind: 'primaryAction',
                id: VOICE_MODE_PLUGIN_ID,
                priority: VOICE_MODE_PRIORITY,
                when: ({ hasDraft, status }) => isEnabled && !hasDraft && status === 'idle',
                action: () => ({
                    ariaLabel: label,
                    icon: isActive ? $icon('player-stop-filled') : $icon('custom-perplexity-v2v'),
                    onPress: onOpen,
                }),
            },
        ],
    });
}
//# sourceMappingURL=index.js.map